// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"fde1d499","791":"a33491bb"}[chunkId] + ".chunk.js";
};